var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1977_3333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.66548 1.1903C6.56002 0.970681 6.39466 0.785327 6.18845 0.655595C5.98223 0.525863 5.74356 0.457031 5.49994 0.457031C5.25631 0.457031 5.01764 0.525863 4.81143 0.655595C4.60522 0.785327 4.43986 0.970681 4.3344 1.1903L0.614563 8.50759C0.169522 9.38117 0.731897 10.5412 1.77965 10.5412H9.22023C10.268 10.5412 10.8294 9.38163 10.3853 8.50759L6.66548 1.1903ZM5.49994 3.66622C5.6215 3.66622 5.73807 3.7145 5.82403 3.80046C5.90998 3.88641 5.95827 4.00299 5.95827 4.12455V6.41621C5.95827 6.53777 5.90998 6.65435 5.82403 6.74031C5.73807 6.82626 5.6215 6.87455 5.49994 6.87455C5.37838 6.87455 5.2618 6.82626 5.17585 6.74031C5.08989 6.65435 5.0416 6.53777 5.0416 6.41621V4.12455C5.0416 4.00299 5.08989 3.88641 5.17585 3.80046C5.2618 3.7145 5.37838 3.66622 5.49994 3.66622ZM5.49994 7.56205C5.6215 7.56205 5.73807 7.61034 5.82403 7.69629C5.90998 7.78224 5.95827 7.89882 5.95827 8.02038V8.24955C5.95827 8.37111 5.90998 8.48769 5.82403 8.57364C5.73807 8.65959 5.6215 8.70788 5.49994 8.70788C5.37838 8.70788 5.2618 8.65959 5.17585 8.57364C5.08989 8.48769 5.0416 8.37111 5.0416 8.24955V8.02038C5.0416 7.89882 5.08989 7.78224 5.17585 7.69629C5.2618 7.61034 5.37838 7.56205 5.49994 7.56205Z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#F4BD00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1977_3333"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIcon);
export default __webpack_public_path__ + "static/media/alert_icon.721253640b73d33cffed73791a777245.svg";
export { ForwardRef as ReactComponent };